<div class="d-flex flex-wrap" *ngIf="question && question.answers_options.length > 0">
  <div class="w-100 bloc-resp-images drop-multiple gap-3 flex-wrap flex-md-nowrap">
    <div *ngFor="let opt of question.answers_options"
         [class.drag-disabled]="isDraggable(opt) == null"
         [class.border]="!opt.image"
         [class.all-size]="!opt.image"
         [attr.draggable]="isDraggable(opt)"
         (dragstart)="app.dragDropHelper.onDragStart($event, opt)"
         class="d-flex align-items-center justify-content-center"
         [ngStyle]="{'background-image': 'url(' + opt.image + ')'}">
      <h4 class="p-2 p-md-4 mb-0 color-black fw-bold" *ngIf="opt.label" [innerHtml]="opt.label"></h4>
    </div>
  </div>
</div>

<div class="w-100 d-flex justify-content-around gap-3 mt-3 mb-5 flex-wrap flex-md-nowrap">

  <div class="drop-area drop-multiple"
       *ngFor="let zone of drop_zones; let i = index"
       [class.drag-over]="zone.is_drag_over"
       [class.order-type]="question.type === QstTypes.DropzoneMultiple"
       (drop)="app.dragDropHelper.onDrop($event, drop_zones, i); onAnswerChange()"
       (dragover)="app.dragDropHelper.onDragOver($event, drop_zones,  i)"
       (dragleave)="app.dragDropHelper.onDragLeave($event, drop_zones,  i)">

    <button role="button" [disabled]="disabled" class="btn-fixed-in-area delete-btn"
       (click)="deleteObjDropzone(drop_zones, i)">
      <i class="material-symbols-outlined">delete</i>
    </button>

    <div *ngIf="!zone.id">
      <div class="text-center">
        <span [innerHtml]="txt_in_drop_zone"></span>
        <h1 class="fw-bold color-red fs-1" [innerHtml]="i + 1"></h1>
      </div>
    </div>

    <div *ngIf="zone.id" [ngStyle]="{'background-image': 'url(' + zone.image + ')'}">
      <h4 class="p-2 p-md-4 color-black fw-bold" *ngIf="zone.label" [innerHtml]="zone.label"></h4>
    </div>
    <p *ngIf="zone.id" class="btn-fixed-in-area order fw-bold color-red" [innerHtml]="i + 1"></p>

  </div>
</div>
